<div #dialog class="bg-gray-100 rounded-xl shadow-xl h-full max-h-[90vh] overflow-hidden flex flex-col" 
  [class]="isMobile() ? 'w-[calc(100%-32px)] mx-4' : 'w-full'">
  <div class="flex items-center px-6 py-4" [class]="showCloseButton ? 'justify-between' : 'justify-center'">
    <h2 class="text-lg font-semibold text-gray-800">
      <ng-content select="[dialog-header]"></ng-content>
    </h2>
    @if(showCloseButton) {
      <button
        class="w-10 h-10 text-gray-500 rounded-full hover:bg-gray-200 text-3xl cursor-pointer transition-all duration-300"
        (click)="close()">
        &times;
      </button>
    }
  </div>

  <div [class]="{'p-6': !noContentPadding}" class="overflow-y-auto">
    <ng-content select="[dialog-content]"></ng-content>
  </div>

  <div class="p-6 flex justify-end gap-2 relative">
    <ng-content select="[dialog-actions]"></ng-content>
  </div>
</div>